import { useMutation, useQueryClient } from '@tanstack/react-query';

import { displayToastError } from '@/helpers/display-toast';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidatePermissionsQueries } from '@/modules/common/utils/query-invalidation';

import { updatePermissions } from '../../api/permissions.api';

export const useUpdatePermissions = () => {
  const queryClient = useQueryClient();
  const { getErrorMessage } = useApiError();

  return useMutation({
    mutationFn: updatePermissions,
    onSuccess: async () => {
      // Refetch rather than seeding from the response: the endpoint returns only a status code.
      await invalidatePermissionsQueries(queryClient);
    },
    onError: (error: unknown) => {
      displayToastError(getErrorMessage(error, true));
    },
  });
};
